

































































import { Component, Vue, Ref } from "vue-property-decorator";
import BiBubbleChart from "./BiBubbleChart";
import axios from "axios";

@Component({
  name: "BiBusinessInteractionChart",

  components: {
    BiBubbleChart
  }
})
export default class Funnel extends Vue {
  @Ref("cy") cy!: HTMLDivElement;
  @Ref("tab") tab!: HTMLDivElement;

  activeName: string = "first";


  tabs = [
    {
      route: "/expert/onboarding/step1",
      title: `${this.$t('msb.tab_interested')}`
    },
    {
      route: "/expert/onboarding/step2",
      title: `${this.$t('msb.tab_interact')}`
    },
    {
      route: "/expert/onboarding/step3",
      title: `${this.$t('msb.tab_collaborate')}`
    }
  ];

  interestedData: Array<Object> = [];
  interactData: Array<Object> = [];
  collaborateData: Array<Object> = [];

  get itemData() {
    if(this.activeName === 'first') {
      return this.interactData
    }

    if(this.activeName === 'second') {
      return this.interestedData
    }
    return this.collaborateData;
  }

  tabClick(){
        if(this.activeName === 'first') {
            this.$gtag.event('BI_sme_graph_1')
        }
        if(this.activeName === 'second') {
           this.$gtag.event('BI_sme_graph_2')
        }
         if(this.activeName === 'third') {
           this.$gtag.event('BI_sme_graph_3')
        }
  }


  chartData(nodes: []) {
    let charts: Array<Object> = [];
    nodes.forEach((item: any) => {
      charts.push({
        type: "nodes",
        id: item.id,
        score: item.value,
        text: item.name
      });

      if (item.relations) {
        item.relations.forEach((id: number) => {
          charts.push({
            type: "edges",
            source: item.id,
            target: id
          });
        });
      }
    });

    return charts;
  }

  mounted() {
    axios.get(`${process.env.VUE_APP_API_URL}analytics/task-views-count`).then(res => {
      return (this.interactData= this.chartData(res.data.values));
    });
    axios.get(`${process.env.VUE_APP_API_URL}analytics/favorite-tasks-count`).then(res => {
      return (this.interestedData = this.chartData(res.data.values));
    });
    axios.get(`${process.env.VUE_APP_API_URL}analytics/active-tasks-count`).then(res => {
      return (this.collaborateData = this.chartData(res.data.values));
    });
  }
}
